module.exports = __webpack_public_path__ + "static/media/20190309_122350.2c77dc1d.jpg";